import {useEffect} from 'react';

import {useDispatch} from 'react-redux';

import {useHostSelector} from 'hooks/hostHooks/hostHooks';
import {getRouterInfo} from 'selectors/router';

import {routerInfoUpdated} from '../../store/reducers/sagaStep/sagaStep';

/**
 *  Hook for dispatching action when routerInfo updates
 */
export const useOnRouterInfoUpdate = () => {
    const routerInfo = useHostSelector(getRouterInfo);
    const dispatch = useDispatch();

    useEffect(() => {
        if (routerInfo.status === 'fulfilled') {
            dispatch(routerInfoUpdated());
        }
    }, [dispatch, routerInfo]);
};
